"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToAddress = void 0;
var firestore_1 = require("firebase/firestore");
var toNumber = function (value) {
    if (typeof value === "number" && Number.isFinite(value)) {
        return value;
    }
    if (typeof value === "string") {
        var parsed = Number.parseFloat(value.trim());
        if (Number.isFinite(parsed)) {
            return parsed;
        }
    }
    return null;
};
var getLatLng = function (value) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (value == null) {
        return null;
    }
    if (value instanceof firestore_1.GeoPoint) {
        return { lat: value.latitude, lng: value.longitude };
    }
    if (typeof value === "string") {
        var pieces = value.split(",");
        if (pieces.length === 2) {
            var lat = toNumber(pieces[0]);
            var lng = toNumber(pieces[1]);
            if (lat != null && lng != null) {
                return { lat: lat, lng: lng };
            }
        }
        return null;
    }
    if (Array.isArray(value) && value.length >= 2) {
        var lat = toNumber(value[0]);
        var lng = toNumber(value[1]);
        if (lat != null && lng != null) {
            return { lat: lat, lng: lng };
        }
        return null;
    }
    if (typeof value === "object") {
        var source = value;
        if (typeof source.lat === "function" && typeof source.lng === "function") {
            var lat_1 = toNumber(source.lat());
            var lng_1 = toNumber(source.lng());
            if (lat_1 != null && lng_1 != null) {
                return { lat: lat_1, lng: lng_1 };
            }
        }
        var lat = (_c = (_b = (_a = toNumber(source.latitude)) !== null && _a !== void 0 ? _a : toNumber(source.lat)) !== null && _b !== void 0 ? _b : toNumber(source._lat)) !== null && _c !== void 0 ? _c : toNumber(source.latitudeDegrees);
        var lng = (_h = (_g = (_f = (_e = (_d = toNumber(source.longitude)) !== null && _d !== void 0 ? _d : toNumber(source.lng)) !== null && _e !== void 0 ? _e : toNumber(source.long)) !== null && _f !== void 0 ? _f : toNumber(source.lon)) !== null && _g !== void 0 ? _g : toNumber(source._long)) !== null && _h !== void 0 ? _h : toNumber(source.longitudeDegrees);
        if (lat != null && lng != null) {
            return { lat: lat, lng: lng };
        }
    }
    return null;
};
var toDate = function (value) {
    if (value instanceof Date && !Number.isNaN(value.getTime())) {
        return value;
    }
    if (typeof value === "string" || typeof value === "number") {
        var parsed = new Date(value);
        if (!Number.isNaN(parsed.getTime())) {
            return parsed;
        }
    }
    return new Date();
};
var mapToAddress = function (address) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var newAddressObject = {
        full_address: "",
        date_updated: new Date(),
        homeErf: "",
        latitude: 0,
        longitude: 0,
    };
    if (address == null) {
        return newAddressObject;
    }
    if (typeof address === "string") {
        return __assign(__assign({}, newAddressObject), { full_address: address });
    }
    if (typeof address !== "object") {
        return newAddressObject;
    }
    var source = address;
    var coords = (_c = (_b = (_a = getLatLng(source.location)) !== null && _a !== void 0 ? _a : getLatLng(source.coordinates)) !== null && _b !== void 0 ? _b : getLatLng(source.coords)) !== null && _c !== void 0 ? _c : getLatLng(source);
    return {
        full_address: ((_e = (_d = source.full_address) !== null && _d !== void 0 ? _d : source.fullAddress) !== null && _e !== void 0 ? _e : "").toString(),
        date_updated: toDate((_f = source.date_updated) !== null && _f !== void 0 ? _f : source.dateUpdated),
        homeErf: ((_j = (_h = (_g = source.homeErf) !== null && _g !== void 0 ? _g : source.HomeErf) !== null && _h !== void 0 ? _h : source.home_erf) !== null && _j !== void 0 ? _j : "").toString(),
        latitude: coords != null ? coords.lat : 0,
        longitude: coords != null ? coords.lng : 0,
    };
};
exports.mapToAddress = mapToAddress;
